import { render } from "./Pesquisa.vue?vue&type=template&id=c3b82944&scoped=true"
import script from "./Pesquisa.vue?vue&type=script&lang=js"
export * from "./Pesquisa.vue?vue&type=script&lang=js"

import "./Pesquisa.vue?vue&type=style&index=0&id=c3b82944&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3b82944"]])

export default __exports__